import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import RequestDemoButton from 'components/RequestDemoButton';
import { Col, Container, Image, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import teamWorkImage from 'assets/images/Youth-Programs-cap60.jpeg';
import styles from './programs.module.scss';
const REPORT_DATA = [
  {
    title: '',
    items: [
      'Attendance & Meal Counts',
      'Youth and Family Information',
      'Customizable Demographic',
      'Service Details & Summaries',
      'Birthday Reports',
      'Assessments & Survey Results',
      'Enrollment and Eligibility Points',
      'Incident Reports',
      'Emergency Contacts',
    ],
  },
];

const FEATURE_DATA = [
  {
    id: 1,
    title: 'Take Group Attendance',
  },
  {
    id: 2,
    title: 'Centralize Data Across Multiple Sites',
  },
  {
    id: 3,
    title: 'Keep Families Informed and Engaged with Outreach Tools',
  },
  {
    id: 4,
    title: 'Maintain Inventory of Consumable Food Items',
  },
  {
    id: 5,
    title: 'Track Usage and Replacement Needs of Toys, Technology and More',
  },
];
function YouthPrograms() {
  return (
    <div>
      <Helmet>
        <title>Youth Programs - CAP60</title>
        <meta
          name="description"
          content="CAP60  address many areas of youth programs and after school programs at-risk behavior, medical or educational needs, mentoring, scholarships, job readiness programs, and more."
        />
        <meta name="keywords" content="youth programs, cap60 youth program" />
      </Helmet>
      <PageBanner
        title="Youth Programs"
        subtitle="Track and Report with Confidence"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport data={REPORT_DATA} title="Reports" />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Track and Report with Confidence</h2>
          </div>
          <p>
            Youth and After School programs are a critical component to many
            Community Action Agencies. CAP60 address many areas of youth
            programs and after school programs at-risk, medical or educational
            needs, mentoring, scholarships, job readiness programs, and more{' '}
            <br />— we offer a highly customizable client and case management
            platform that can be tailored to fit your organization’s specific
            needs. This allows us to deliver solutions that more closely align
            with your systems and processes.
          </p>
          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

function SampleReport({ data, title }) {
  return (
    <div className={styles.sampleReportWrapper}>
      <Container>
        <div className="heading">{!!title && <h2> {title}</h2>}</div>
        <Row>
          {data.map((rdata, idx) => (
            <Col md="6" key={idx}>
              <div className={styles.reportList}>
                <h3>{rdata.title}</h3>
                <ul>
                  {rdata.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default YouthPrograms;
